var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"title":_vm.$t('pages.starter.title')}}),_vm._v(" 1234567890 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }